import { render, staticRenderFns } from "./RegistrationSettings.vue?vue&type=template&id=86aa64fc&scoped=true&"
import script from "./RegistrationSettings.vue?vue&type=script&lang=js&"
export * from "./RegistrationSettings.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSettings.vue?vue&type=style&index=0&id=86aa64fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aa64fc",
  null
  
)

export default component.exports